import PropTypes from 'prop-types';

export const GalleryIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7602_5638)">
        <path
          d="M24.5334 7.46536V20.2654H11.7334V7.46536H24.5334ZM24.5334 5.33203H11.7334C10.56 5.33203 9.60004 6.29203 9.60004 7.46536V20.2654C9.60004 21.4387 10.56 22.3987 11.7334 22.3987H24.5334C25.7067 22.3987 26.6667 21.4387 26.6667 20.2654V7.46536C26.6667 6.29203 25.7067 5.33203 24.5334 5.33203ZM15.4667 15.6467L17.2694 18.0574L19.9147 14.7507L23.4667 19.1987H12.8L15.4667 15.6467ZM5.33337 9.5987V24.532C5.33337 25.7054 6.29337 26.6654 7.46671 26.6654H22.4V24.532H7.46671V9.5987H5.33337Z"
          fill={className}
        />
      </g>
      <defs>
        <clipPath id="clip0_7602_5638">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

GalleryIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};
